import React from 'react'
import { Card, Row, Col, Statistic, Table } from 'antd'
import { ConnectionInfo } from '../interfaces/interfaces'
import { connectionsColumns } from '../columns'
import { EmptyState } from '../styles'

interface ConnectionsProps {
  connections: ConnectionInfo | null
}

export const Connections: React.FC<ConnectionsProps> = ({ connections }) => {
  const connectionsData = connections
    ? [
        ...connections.smtp.connections.map(c => ({ ...c, type: 'SMTP' })),
        ...connections.imap.connections.map(c => ({ ...c, type: 'IMAP' }))
      ]
    : []

  return (
    <Card title="Соединения SMTP/IMAP" style={{ marginBottom: 16 }}>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Statistic title="SMTP соединений" value={connections?.smtp.count || 0} />
        </Col>
        <Col span={12}>
          <Statistic title="IMAP соединений" value={connections?.imap.count || 0} />
        </Col>
      </Row>

      {connectionsData.length > 0 ? (
        <Table
          dataSource={connectionsData}
          columns={connectionsColumns}
          rowKey={(record) => `${record.type}-${record.officeId}`}
          pagination={false}
          size="small"
        />
      ) : (
        <EmptyState>Нет активных соединений</EmptyState>
      )}
    </Card>
  )
}

